export const HEADER_SORT_RESERVE = 50;
export const HEADER_NO_SORT_RESERVE = 10;

const HEADER_FONT = '600 14px "Geist", sans-serif';
const HEADER_CELL_PADDING = 20;
const HEADER_CHECKBOX_EXTRA = 26;
const HEADER_WIDTH_BUFFER = 2;

export const CUSTOM_HEADER_GEOMETRY = {
  sortReserve: HEADER_SORT_RESERVE,
  plainReserve: HEADER_CELL_PADDING
};

export const NATIVE_HEADER_GEOMETRY = {
  sortReserve: 46,
  plainReserve: HEADER_CELL_PADDING
};

let measureContext = null;
let measureContextInitialized = false;
const widthCache = new Map();

const getMeasureContext = () => {
  if (!measureContextInitialized) {
    measureContextInitialized = true;
    measureContext =
      typeof document !== 'undefined' ? document.createElement('canvas').getContext('2d') : null;
  }
  return measureContext;
};

const measureHeaderText = (text) => {
  if (widthCache.has(text)) return widthCache.get(text);

  const context = getMeasureContext();
  if (!context) return 0;

  context.font = HEADER_FONT;
  const width = context.measureText(text).width;

  if (width > 0 && (!document.fonts || document.fonts.check(HEADER_FONT))) {
    widthCache.set(text, width);
  }

  return width;
};

export const getHeaderMinWidthDef = (col, defaultColDef, geometry = CUSTOM_HEADER_GEOMETRY) => {
  const headerName = typeof col?.headerName === 'string' ? col.headerName.trim() : '';
  if (!headerName || col?.field === 'actions') return {};

  const textWidth = measureHeaderText(headerName);
  if (!textWidth) return {};

  const sortable = col.sortable ?? defaultColDef?.sortable ?? true;
  const reserve = sortable ? geometry.sortReserve : geometry.plainReserve;
  const checkboxExtra = col.headerCheckboxSelection ? HEADER_CHECKBOX_EXTRA : 0;

  let computed = Math.ceil(textWidth) + reserve + checkboxExtra + HEADER_WIDTH_BUFFER;
  if (col.maxWidth != null) computed = Math.min(computed, col.maxWidth);

  const floor = col.minWidth ?? defaultColDef?.minWidth ?? 0;
  return computed > floor ? { minWidth: computed } : {};
};

export const applyHeaderMinWidths = (cols, defaultColDef, geometry = CUSTOM_HEADER_GEOMETRY) =>
  cols?.map((col) => {
    const minWidthDef = getHeaderMinWidthDef(col, defaultColDef, geometry);
    return minWidthDef.minWidth ? { ...col, ...minWidthDef } : col;
  });
